import { createContext, useContext } from 'react';
import { noop } from 'utils/noop';
import { PredictiveAudienceGoal, VocabularyResponse } from '../../../types';

export interface CoreGoalsContext {
  areAllReady: boolean;
  isError: boolean;
  isLoading: boolean;
  goals: {
    goalData: Array<PredictiveAudienceGoal>;
    retrigger: () => void;
    isError: boolean;
  };
  vocab: {
    vocabData: VocabularyResponse;
    retrigger: () => void;
    isError: boolean;
  };
}

export const defaultCoreGoalsContext = {
  areAllReady: false,
  isError: false,
  isLoading: false,
  goals: {
    goalData: [],
    retrigger: noop,
    isError: false,
  },
  vocab: {
    vocabData: {
      predictiveAudiencesVocabulary: {
        customEvents: [],
        purchaseEvents: [],
        systemEvents: [],
        computedFor: '',
      },
    },
    retrigger: noop,
    isError: false,
  },
};

export const CoreGoalsContext = createContext<CoreGoalsContext>(defaultCoreGoalsContext);

export const useCoreGoalsContext = () => useContext(CoreGoalsContext);
